<template>
    <div class="py-4 px-3">
        <div v-if="exchanging" class="mt-3">
            <div class="text-secondary mb-2">
                {{ $t("Signing you in...") }}
            </div>
            <generic-loading />
        </div>
        <div v-else>
            <div class="mt-3 mb-4">
                <font-awesome-icon
                    icon="fa-duotone fa-shield-check"
                    class="text-primary"
                    size="2x"
                />
                <div class="mt-2 text-secondary">
                    {{ $t("Quick security check before we log you in") }}
                </div>
            </div>

            <div
                v-if="nonceKey"
                class="d-flex justify-content-center mb-4"
            >
                <captcha-nonce
                    :uniqueKey="nonceKey"
                    @verified="onVerified"
                    analyticsKey="loginToken"
                />
            </div>

            <div class="mt-4">
                <b-btn
                    variant="link"
                    size="sm"
                    class="text-secondary"
                    @click="bailout"
                >
                    {{ $t("Sign in a different way") }}
                </b-btn>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import CaptchaNonce from "@/components/utility/CaptchaNonce";

export default {
    data() {
        return {
            exchanging: false,
        };
    },
    computed: {
        ...mapState("startup", ["nonceKey"]),
    },
    methods: {
        onVerified(nonce) {
            this.exchanging = true;
            this.$store.dispatch("startup/exchangeLoginToken", { nonce });
        },
        bailout() {
            this.$store.commit("startup/setHasLoginToken", false);
            this.$store.commit("startup/clearLoginToken");
        },
    },
    components: {
        CaptchaNonce,
    },
};
</script>
